module.exports = __webpack_public_path__ + "static/media/Support.69f3e950.svg";